import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BusinessList = _resolveComponent("BusinessList")!

  return (_openBlock(), _createBlock(_component_BusinessList, {
    tabPanelData: _ctx.tabList,
    pageTypeIn: 'ORDER',
    permission: "TO_ORDERED_BUSINESS",
    canCommand: false,
    marketFeeCanCommand: false,
    FilterFieldProps: _ctx.FilterField,
    businessTypeName: "TABLE_TO_ORDERED_BUSINESS",
    HiddenFieldFunProps: (item) => '订单号码、内部订单号、发票号码、发票金额、预计完成天数、开票状态、开票日期、收款状态、收款日期'.split('、').some(fieldName => fieldName === item.fieldName)
  }, null, 8, ["tabPanelData", "FilterFieldProps", "HiddenFieldFunProps"]))
}